// Tab focus only in keyboard use
window.addEventListener('keyup', function tabFocusClass(e) {
  if ( e.which == 9 ) {
    this.document.body.classList.add('tab-focus');
    window.removeEventListener('keyup', tabFocusClass);
  }
});